// eslint-disable-next-line no-unused-vars
const useInitOnboardingComponentExperiment = (canRunExperiment = false) => ({
  isUserInOnboardingExperimentVariation: false,
  isOnboardingComponentExperimentLoaded: true,
});

export const getUserVariation = () => false;

export default useInitOnboardingComponentExperiment;
